<template>
  <div class="footer">
    <div class="store-list">
      <van-collapse v-model="activeName">
        <van-collapse-item title="在线帮助" name="1">
          <div>
            <router-link :to="`/question`">常见问题</router-link>
          </div>
          <div>
            <router-link :to="`/howbuy`">订单说明</router-link>
          </div>
          <div>
            <router-link :to="`/pay-type`">支付方式</router-link>
          </div>
          <div>
            <router-link :to="`/order-delivery`">货物配送</router-link>
          </div>
          <div>
            <router-link :to="`/sale-after`">售后服务</router-link>
          </div>
          <div>
            <a href="http://www.support.philips.com/support/contact/contact_page.jsp;jsessionid=41A74C2E0BB62740DDDEAFF780BA5698.app106-drp1?userCountry=cn&amp;userLanguage=zh" target="_blank">联系我们</a>
          </div>
        </van-collapse-item>
      </van-collapse>
    </div>
    <div class="warp-bottom">
      <div class="footer_logo">
        <div class="footer_logo_left">
          <h3 class="p-body-copy-02">连接至飞利浦</h3>
          <div style="display: flex; align-items: center;">
            <a href="https://www.philips.com.cn/myphilips/myphilips-wechat.html" target="_blank">
              <i class="iconfont icon-weixin"></i>
            </a>
            <a style="margin-left: 10px;margin-top: 2px;" href="http://weibo.com/onesmallstep" target="_blank">
              <i class="iconfont icon-xinlang"></i>
            </a>
          </div>
        </div>
        <div class="footer_logo_center">
          <img style="height: 120px;" src="../assets/images/philips-footer-logo.png" />
        </div>
        <div class="footer_logo_right">
          <a target="_blank" href="https://www.philips.com.cn/">跳转飞利浦官网</a>
        </div>
      </div>
      <ul class="p-grid">
        <li class="p-grid-item">
          <router-link :to="`/terms`">
            <span class="p-text">会员服务协议</span>
          </router-link>
        </li>
        <li class="p-grid-item">
          <a href="https://www.careers.philips.com/cn/zh">
            <span class="p-text">招贤纳士</span>
          </a>
        </li>
        <li class="p-grid-item">
          <a href="http://www.support.philips.com/support/contact/contact_page.jsp?userLanguage=zh&userCountry=cn">
            <span class="p-text">联系飞利浦</span>
          </a>
        </li>
        <li class="p-grid-item">
          <a href="https://www.philips.com.cn/a-w/site-owner.html">
            <span class="p-text">Philips</span>
          </a>
        </li>
        <li class="p-grid-item">
          <router-link :to="`/privacy`">
            <span class="p-text">隐私权声明</span>
          </router-link>
        </li>
        <li class="p-grid-item">
          <a href="https://www.philips.com.cn/a-w/cookie-notice.html">
            <span class="p-text">Cookie 政策</span>
          </a>
        </li>
        <li class="p-grid-item">
          <a href="https://www.philips.com.cn/a-w/terms-of-use.html">
            <span class="p-text">使用条款</span>
          </a>
        </li>
        <li class="p-grid-item">
          <a href="https://www.philips.com.cn/a-w/security.html">
            <span class="p-text">产品安全</span>
          </a>
        </li>
        <li class="p-grid-item">
          <a href="http://www.miibeian.gov.cn/">
            <span class="p-text">沪ICP备09062110号</span>
          </a>
        </li>
        <li class="p-grid-item">
          <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010602001824">
            <span class="p-text">沪公网安备31010602001824号</span>
          </a>
        </li>
      </ul>
      <p style="color: #b3c8e6;line-height: 22px;">© Koninklijke Philips N.V.，2018 - 2024。保留所有权利。</p>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      activeName: ['']
    }
  }
}
</script>

<style lang="scss" scoped>
  .footer {
    height: auto;
    overflow: hidden;
    margin: 0 auto;
    font-size: 12px;
    .store-list {
      width: 100%;
      border-top: 1px solid #E5E5E5;
      border-bottom: 1px solid #E5E5E5;
    }
    .bottom-list {
      height: 300px;
      overflow: hidden;
      filter: progid:DXImageTransform.Microsoft.Gradient(startColorStr='#052371',endColorStr='#00329f',gradientType='1');
      background: -moz-linear-gradient(left,#052371,#00329f);
      background: -webkit-linear-gradient(left,#052371,#00329f);
      background: -ms-linear-gradient(left,#052371,#00329f);
      background: linear-gradient(left,#052371,#00329f);
      a {
        color: #b3d4fc;
        display: inline;
      }
      .bottom-list-content {
        height: 300px;
        overflow: hidden;
        margin: 0 auto;
        background: transparent;
        color: #b3d4fc;
        position: relative;
        .bottom-list-content-center {
          position: absolute;
          width: 80px;
          height: auto;
          left: 50%;
          transform: translateX(-50%);
          top: 45px;
        }
      }
      .bottom-list-content-bottom {
        position: absolute;
        height: auto;
        left: 0;
        width: 100%;
        top: 190px;
        text-align: center;
        line-height: 1.8;
      }
    }
  }
</style>
<style lang="scss">
  @media only screen and (max-width: 1080px) {
    .warp-bottom {
      font-size: 12px;
      .footer_logo_left .p-body-copy-02 {
        font-size: 12px;
      }
    }
  }
  .van-collapse-item {
    .van-cell, .van-collapse-item__content {
      background: #f5f5f5;
    }
    .van-cell {
      padding: 8px 10px;
    }
    .van-cell:not(:last-child)::after {
      left: 0;
      border-bottom: 1px solid #E5E5E5;
    }
    .van-collapse-item__content {
      padding: 0;
      >div {
        padding: 8px 20px;
        border-bottom: 1px solid #E5E5E5;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/MobileFooter.vue